import { IEvent, IHost } from "@Interfaces";
import { EVENT_TYPE, MEDIA } from "@Utils";
import { default_depth_index, getPlanData } from "../../utils/plan";
import { IWrapperComponentType } from "../Interfaces";
import { IEventMedia } from "./EventMedia";
import { IPlanDropdown } from "../PlanDropdown/IPlanDropdown";

export const getEventMediaProps = ({
    host,
    eventData,
    wrapperComponentType,
    planId,
    getDropdownSelectorsProps,
}: {
    host: IHost.IStore;
    eventData: IEvent.IEventData;
    wrapperComponentType: IWrapperComponentType;
    planId?: string;
    getDropdownSelectorsProps: (
        depthIndex: number
    ) => IPlanDropdown.DropdownSelectorsPropsType;
}): IEventMedia.IProps => {
    const { value: selectedValue } =
        getDropdownSelectorsProps(default_depth_index);
    const planData = getPlanData({
        host,
        planId,
    });
    const planImage = planData?.cover_image;
    const { selectedVariant, type, variantsData } = eventData;
    const isMerchandise = type === EVENT_TYPE.MERCHANDISE;
    const hasVariants = !!variantsData?.variants;

    let image = eventData?.cover_image || MEDIA.DEFAULT.CARD_IMAGE;
    const video = eventData?.cover_video;

    let carouselImages = [
        ...(image ? [image] : []),
        ...(eventData?.images || []),
        ...(planImage ? [planImage] : []),
    ];

    if (planImage) {
        if (selectedValue?.value) {
            carouselImages = [
                ...(image ? [image] : []),
                ...(eventData?.images || []),
            ];
        } else {
            carouselImages = [...(planImage ? [planImage] : [])];
            image = planImage;
        }
    }

    if (isMerchandise && hasVariants) {
        const variantImage = selectedVariant?.images?.[0]; // cover image will be first image in case of variant
        image = variantImage || image;
        carouselImages = selectedVariant?.images?.length
            ? selectedVariant.images
            : carouselImages;
    }

    let mediaType: "video" | "imageCarousel" | "image";
    if (video) {
        mediaType = "video";
    } else if (carouselImages.length > 1) {
        mediaType = "imageCarousel";
    } else {
        mediaType = "image";
    }

    return {
        mediaType,
        video,
        carouselImages,
        image,
        wrapperComponentType,
    };
};
